module.exports = __webpack_public_path__ + "static/media/multishow.a864d569.svg";